import { combineReducers } from '@reduxjs/toolkit'

// Import your slice reducers here
import authReducer from '../features/Auth/store/authSlice'
import mediaControlsReducer from '../features/MediaControls/store/mediaControlSlice'
import controlPanelSlice from '../features/ControlPanel/store/controlPanelSlice'
import messagesSlice from './messagesSlice/messagesSlice'
import interactModalSlice from '../features/ControlPanel/store/interact/interactSlice'
import myEventModalSlice from '../features/ControlPanel/store/myEventModal/myEventModalSlice'
import inviteSlice from '../features/ControlPanel/store/Invite/inviteSlice'
import socketSlice from './socketSlice/socketSlice.js'
import MapDisplaySlice from '../features/Map/store/MapDisplaySlice'
import settingsSlice from '../features/ControlPanel/store/settings/settingsSlice'
import livekitSlice from '../features/MediaPlayback/store/livekitSlice/livekitSlice'
import RoomMenuSlice from '../features/Map/store/RoomMenu/RoomMenuSlice.js'
import AddEventSlice from '../features/ControlPanel/store/AddEvent/AddEventSlice'
import avatarSlice from '../features/Map/store/Avatars/AvatarsSlice.js'
import chairSlice from '../features/Map/store/Chairs/ChairsSlice'
import notificationsSlice from '../features/Notifications/store/notificationsSlice.js'
import globalLivekitSlice from '../features/MediaPlayback/store/GlobalLivekitSlice/GlobalLivekitSlice'
import AnnouncementSlice from '../features/ControlPanel/store/Announcement/AnnouncementSlice.js'
import adminSlice from '../features/Administration/store/adminSlice.js'
import userManagementSlice from '../features/ControlPanel/store/userManagement/userManagementSlice.js'
import transcriptionReducer from "../features/MediaPlayback/store/TranscriptionSlice/TranscriptionSlice";
import mediaPlaybackSlice from '../features/MediaPlayback/store/mediaPlaybackSlice.js'
import statisticsSlice from '../features/statistics/store/statisticsSlice.js'
import reactionReducer from "../features/MediaControls/store/reactionSlice.js";
import raisedHandsReducer from "../features/MediaControls/store/raisedHandsSlice";
import profilePhotoSlice from "../features/ControlPanel/store/ProfilePhoto/profilePhotoSlice.js"
import gamesSlice from "../features/Games/store/GamesSlice.js"
import ProductivitySessionSlice from "../features/ProductivitySession/store/ProductivitySessionSlice.js"
import whiteboardSlice from '../features/Whiteboard/store/whiteboardSlice.js'
import coffePauseSlice from '../features/CoffeePause/store/coffePauseSlice.js'
import InscriptionConferenceSlice from  '../features/ConferenceInscription/store/InscriptionConferenceSlice.js'
import CreateConferenceSlice from '../features/ControlPanel/store/Conference/CreateConferenceSlice.js'
import recorderReducer from '../features/ScreenRecording/slice/recorderSlice.js';

import ActiveConferenceSlice from '../features/Conference/store/ActiveConferenceSlice.js'
import SparkSlice from '../features/ControlPanel/store/Spark/SparkSlice.js'
const rootReducer = combineReducers({
  // Add your reducers here
  AddEvent: AddEventSlice,
  admin: adminSlice,
  announcement: AnnouncementSlice,
  auth: authReducer,
  avatars: avatarSlice,
  chairs: chairSlice,
  controlPanel: controlPanelSlice,
  games: gamesSlice,
  globalLivekit: globalLivekitSlice,
  interactModal: interactModalSlice,
  inviteModal: inviteSlice,
  livekit: livekitSlice,
  MapDisplay: MapDisplaySlice,
  mediaControls: mediaControlsReducer,
  mediaPlayback: mediaPlaybackSlice,
  messageHistory: messagesSlice,
  myEventModal: myEventModalSlice,
  notifications: notificationsSlice,
  productivitySession: ProductivitySessionSlice,
  profilePhoto: profilePhotoSlice,
  raisedHands: raisedHandsReducer,
  reactions: reactionReducer,
  RoomMenu: RoomMenuSlice,
  settingsModal: settingsSlice,
  socket: socketSlice,
  statistics: statisticsSlice,
  transcription: transcriptionReducer,
  userManagement: userManagementSlice,
  whiteboard: whiteboardSlice,
  coffePause:coffePauseSlice,
  InscriptionConference:InscriptionConferenceSlice,
  createConference:CreateConferenceSlice,
  activeConference:ActiveConferenceSlice,
  recorder: recorderReducer,
  // You can add more slices as needed
  Spark:SparkSlice,

  app: (state = { initialized: true }, action) => state,
})

export default rootReducer
